import { Typography } from '@mui/material';
import React from 'react';

const ConsolidatedVesselSchedulePage = (props) => {
    return (
        <>
            <Typography variant={'h2'}>Consolidated Vessel Schedule</Typography>
            {/* Display the BasicBarChart component */}
            {/* <BarChartBasic dataset={dataset} xAxis={xAxis} series={series} /> */}

            
        </>
    );
};

export { ConsolidatedVesselSchedulePage };